export var CustomerFieldRequirement;
(function (CustomerFieldRequirement) {
    CustomerFieldRequirement["Required"] = "Required";
    CustomerFieldRequirement["Optional"] = "Optional";
    CustomerFieldRequirement["Disabled"] = "Disabled";
})(CustomerFieldRequirement || (CustomerFieldRequirement = {}));
export function getCustomerFieldRequirementName(requirement) {
    switch (requirement) {
        case CustomerFieldRequirement.Required: return $t('%Qk');
        case CustomerFieldRequirement.Optional: return $t('%14p');
        case CustomerFieldRequirement.Disabled: return $t('%Zr4');
    }
}
//# sourceMappingURL=CustomerFieldRequirement.js.map